/*
 * @Description:申请开票 
 * @Author: ywj
 * @Date: 2025-03-24 16:53:48
 * @LastEditTime: 2025-04-23 16:11:43
 * @LastEditors: Please set LastEditors
 */
import React, { useState, useEffect } from 'react'
import { useLocation,useNavigate } from 'react-router-dom';
import { Modal, Button, message } from 'antd';
import tipIcon from '../../imgs/tips.png'
import NoData from '@/components/no-data';
import { getBillBaseList, deleteBill } from '@/api/personal-center'
import './index.scss';
import { IInvoiceItem } from '../../../invoice/type';
import DeleteModal from "../../../components/delete-modal";
import Card from '../../../invoice/components/card'
import InvoiceModal from "../../../invoice/components/add-modal";
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { createBill,updateBillInfo} from '@/api/my-invoice';
interface IApplyProps {
  showApplyModal: boolean;
  setShowApplyModal: (showApplyModal: boolean) => void;
  isChange: number;
  orderId?: number | string;
  id?: number|string;
  billId?: number |string;
  setIsRefresh?: any

}
const ApplyModal: React.FC<IApplyProps> = (props) => {
  const [invoiceData, setInvoiceData] = useState<IInvoiceItem[]>([]);
  const [showAddModal, setShowAddModal] = React.useState(false)
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [selectId, setSelectId] = useState<number>();
  const [invoiceItem, setInvoiceItem] = useState<IInvoiceItem | null>();
  // toggle 发票列表
  const [isShowAllInvoice, setIsShowAllInvoice] = useState(false);
  const [invoiceId, setInvoiceId] = useState<number>();
  const { showApplyModal, setShowApplyModal, orderId = '', isChange, id = null, billId = null, setIsRefresh, } = props;
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location,'location')
  useEffect(() => {
    handleInvoiceData();
  }, [showApplyModal,showAddModal]);
  const handleEdit = (obj: IInvoiceItem) => {
    setShowAddModal(true);
    setInvoiceItem(obj);
  }
  const handleDeletes = (id: number) => {
    setInvoiceItem(null)
    setShowDeleteModal(true);
    setSelectId(id);

  }

  const handleAddInvoice = () => {
    if (invoiceData.length > 10 || invoiceData.length === 10) {
      message.error('已存在10条发票抬头数据，请勿重复操作');
      return false;
    }
    setInvoiceItem(null)
    setShowAddModal(true);
  }
  const handleInvoiceData = () => {
    getBillBaseList().then((res: any) => {
      if (res?.success) {
        console.log(res, 'res')
        setInvoiceData(res.obj);
        setInvoiceId(res.obj.find((item: any) => item.id === billId)?.id||null);
      } else {
        message.error(res.message);
      }
    })
  }
  const haddleDeleteCard = () => {
    if (selectId) {
      deleteBill(selectId).then((res: any) => {
        if (res.success) {
          message.success('删除成功');
          setShowDeleteModal(false);
          handleInvoiceData();
        } else {
          message.error(res.message);
        }
      })
    }
  }
  const handleChangeInvoice= (id:number) => { 
    setInvoiceId(id);
  }
// 申请开票
  const handleApply =()=>{
    console.log(invoiceId, isChange, 'invoiceId');
    const apis = isChange === 1 ? createBill : updateBillInfo;
    const params1 = {
      billId: invoiceId, orderId: orderId
    }
    const params2 = { billId: invoiceId, orderId: orderId, id: id }
    const params =isChange===1?params1:params2;
    apis(params).then((res: any) => {
      if (res.success) { 
        message.success('申请成功');
        setShowApplyModal(false);
        if(setIsRefresh) {
          setIsRefresh(true);
        }
        if (location.pathname !== '/user/receipt') { 
          navigate('/user/receipt')
        }
      }else{
        message.error(res.message)
      }
    })
  }
  return (
    <Modal
      width={950}
      centered
      open={showApplyModal}
      title='申请开票'
      className='my-invoice-apply-modal'
      onCancel={() => setShowApplyModal(false)}
    >
      <div className="tips-box">
        <img src={tipIcon} alt="提示" className='tips' />
        电子发票与纸质发票具有同等法律效力，可支持报销入账；同时根据增值税管理办法要求，如需为企业开具增值税发票，需提供纳税人识别号或统一社会信用代码，否则该发票无法作为税收凭证。
      </div>
      <div className="titles">
        <span>发票抬头</span>
        <span className='add' onClick={handleAddInvoice}>新增发票抬头</span>
      </div>
      {invoiceData.length > 0 ?  <div className="my-invoice-card-container">
        
        {(isShowAllInvoice ? invoiceData : invoiceData.slice(0, 4)).map((item: IInvoiceItem) => {
          return <Card
            key={item.id}
            {...item}
            handleEdit={() => handleEdit(item)}
            handleDelete={() => handleDeletes(item?.id)}
            handleInvoiceData={handleInvoiceData}
            canChecked={true}
            onClick={() => handleChangeInvoice(item.id)}
            invoiceId={invoiceId}

          />
        })}
          
      </div> : <div style={{marginBottom:'-100px'}}> <NoData /></div>}
     {invoiceData.length > 4&& <><div
        className="toggle-btn"
        onClick={() => setIsShowAllInvoice(!isShowAllInvoice)}
      >
        <span className='text'>
          {isShowAllInvoice ? '收起' : '查看全部'}
        </span>
        {isShowAllInvoice ? <UpOutlined /> : <DownOutlined />}
      </div></>}
      <div className="dialog-bottom">
        <Button className='submit-info' onClick={handleApply}>提交申请</Button>
        <Button onClick={ ()=>setShowApplyModal(false)}>取消</Button>
      </div>
      <InvoiceModal
        showModal={showAddModal}
        setShowAddModal={setShowAddModal}
        invoiceItem={invoiceItem}

      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        handleDelete={haddleDeleteCard}
        title='删除提醒'
        content='请确认是否删除该发票？'
      />
    </Modal>
  )
};
export default ApplyModal;